module.exports = __webpack_public_path__ + "img/thesis00.1bd54127.jpg";